import React from 'react';
import { bool, any, func } from 'prop-types';
import {
  Accordion,
  App as PropulsionApp
} from '@ui-propulsion/react-components';
import InformationBox from '../InformationBox';
import { heapTrackEvent } from '../../../heap-track-events/heapTrackEvents';

const FAQNoteClassName = 'FAQNote';
const CheckMarkIcon = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${FAQNoteClassName}-checkMarkIcon`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM5 12.42l5 5 9-9L17.59 7 10 14.59l-3.59-3.58L5 12.42Z"
      fill="#4E9603"
    />
  </svg>
);

const ListItem = ({ children }) => {
  return (
    <li data-testid="list-element">
      <CheckMarkIcon />
      {children}
    </li>
  );
};
ListItem.propTypes = {
  children: any
};

const accordionContentDefault = [
  {
    id: FAQNoteClassName,
    header: 'What can I include as total annual income?',
    className: `${FAQNoteClassName}-section`,
    details: (
      <div className={`${FAQNoteClassName}-detailsWrapper`}>
        <p className={`${FAQNoteClassName}-description`}>
          Some examples of income include the following:
        </p>
        <ul className={`${FAQNoteClassName}-details`}>
          <ListItem>
            <p>
              <b>Income from employment,</b> including full-time, part-time,
              freelance, or seasonal jobs
            </p>
          </ListItem>
          <ListItem>
            <p>
              <b>Self-employment,</b> including any business dividends or rental
              income
            </p>
          </ListItem>
          <ListItem>
            <div>
              <p>
                <b>Any other income</b> such as retirement, social security, or
                public assistance
              </p>
              <p className="FAQNote-spacing">
                <b>Important notes:</b>
              </p>
              <ul className="FAQNote-list">
                <li>
                  Non-taxable income, if included, should be increased by 25%.
                </li>
                <li>
                  Alimony, child support or separate maintenance income need not
                  to be included if you do not wish to have it considered as a
                  basis for repaying this obligation.
                </li>
                <li>
                  Married Wisconsin Residents Only: If you are applying for an
                  individual account and your spouse is also a WI resident,
                  combine your and your spouse’s financial information.
                </li>
              </ul>
            </div>
          </ListItem>
        </ul>
      </div>
    )
  }
];

export const FAQNote = ({ opened, onChange }) => {
  const handleOnChange = e => {
    onChange(e, !opened);
    heapTrackEvent('Auto Income FAQNote', {
      openState: opened ? 'Opened' : 'Closed'
    });
  };

  return (
    <div className={`${FAQNoteClassName}`}>
      <PropulsionApp>
        <InformationBox className={`${FAQNoteClassName}-container`}>
          <Accordion
            className={`${FAQNoteClassName}-accordion`}
            expanded={{
              [FAQNoteClassName]: opened
            }}
            onChange={handleOnChange}
            data={accordionContentDefault}
          />
        </InformationBox>
      </PropulsionApp>
    </div>
  );
};

FAQNote.propTypes = {
  opened: bool,
  onChange: func
};

FAQNote.defaultProps = {
  opened: false,
  onChange: () => {}
};

require('/var/lib/jenkins/workspace/auto-borrower-apply-ui_Release_0/src/shared_modules/propulsion/components/FAQNote/FAQNote.scss');